import * as React from 'react';
import { StyleRulesCallback, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    progress: {
        background: undefined
    }
});

type WithStylesProps = "progress";

interface TableLoadingIndicatorProps {
    loading: boolean,
    loadingText: string
}

type IndicatorProps = TableLoadingIndicatorProps & WithStyles<WithStylesProps>;

const TableLoadingIndicator: React.SFC<IndicatorProps> = (props) => {
    const { classes } = props;
    return props.loading ?
        <Grid container direction="column" alignItems="center" style={{ position: "relative", zIndex: 1 }}>
            <Grid item><CircularProgress className={classes.progress} thickness={5} color="secondary" /></Grid>
            <Grid item><Typography color="primary">{props.loadingText}</Typography></Grid>
        </Grid>
        : null;
};

export default withStyles(styles)(TableLoadingIndicator) as typeof TableLoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/tables/TableLoadingIndicator.tsx